import { getSummary, getCloseOrderReason, getDeliveryRate, getCustomerOrder, getCategoryAnalysis, getOrderType, getShipInfo, exportData, getDashboardRejectReturn, getDashboardTop5, getDashboardFillRate } from './../api';
import { getSoldToList, getDcNoList } from '../../../../api/index';
const cscDashboard = {
  namespaced: true,
  state: {
    successCode: 200,
    // 1. 顶部汇总
    summaryData: null,
    // 2. 各关单原因TOP3
    closeOrderReasonData: null,
    // 3. 首次送货满足率
    deliveryRateData: null,
    // 4. 客户订单
    customerOrderData: null,
    // 5. 订单分析-品类
    categoryAnalysisData: null,
    // 6. 订单分析-订单类型
    orderTypeData: null,
    // 7. 客户发货信息
    shipInfoData: null,
    //退货信息
    rejectReturnData: null,
    // 下拉列表
    soldToListData: null,
    dcNoListData: null,
    dashboardTop5Data: null,
    dashboardFillRateData: null,
    // 导出
    exportData: null
  },
  mutations: {
    // 1. 顶部汇总
    GET_SUMMARY_DATA(state, data) {
      state.summaryData = data;
    },
    //top5
    GET_DASHBOARD_TOP5(state, data) {
      state.dashboardTop5Data = data;
    },
    //整体订单满足率
    GET_DASHBOARD_FILL_RATE(state, data) {
      state.dashboardFillRateData = data;
    },
    // 2. 各关单原因TOP3
    GET_CLOSE_ORDER_REASON_DATA(state, data) {
      state.closeOrderReasonData = data;
    },
    // 3. 首次送货满足率
    GET_DELIVERY_RATE_DATA(state, data) {
      state.deliveryRateData = data;
    },
    // 4. 客户订单
    GET_CUSTOMER_ORDER_DATA(state, data) {
      state.customerOrderData = data;
    },
    // 5. 订单分析-品类
    GET_CATEGORY_ANALYSIS_DATA(state, data) {
      state.categoryAnalysisData = data;
    },
    // 6. 订单分析-订单类型
    GET_ORDER_TYPE_DATA(state, data) {
      state.orderTypeData = data;
    },
    // 7. 客户发货信息
    GET_SHIP_INFO_DATA(state, data) {
      state.shipInfoData = data;
    },
    GET_DASHBOARD_REJECT_RETURN(state, data) {
      state.rejectReturnData = data;
    },
    // soldTo下拉列表
    GET_SOLDTO_LIST(state, data) {
      state.soldToListData = data;
    },
    GET_SHIPTO_LIST(state, data) {
      state.shipToListData = data;
    },
    // dcNo下拉列表
    GET_DCNO_LIST(state, data) {
      state.dcNoListData = data;
    },
    // 导出
    GET_EXPORT_DATA(state, data) {
      state.exportData = data;
    }
  },
  actions: {
    // 1. 顶部汇总
    async getSummaryData({ commit }, obj) {
      let resp = await getSummary(obj);
      commit('GET_SUMMARY_DATA', resp);
    },
    /**
     * top5
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async getDashboardTop5({ commit }, obj) {
      let resp = await getDashboardTop5(obj);
      commit('GET_DASHBOARD_TOP5', resp);
    },
    /**
     * 整体订单满足率
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async getDashboardFillRate({ commit }, obj) {
      let resp = await getDashboardFillRate(obj);
      commit('GET_DASHBOARD_FILL_RATE', resp);
    },
    // 2. 各关单原因TOP3
    async getCloseOrderReasonData({ commit }, obj) {
      let resp = await getCloseOrderReason(obj);
      commit('GET_CLOSE_ORDER_REASON_DATA', resp);
    },
    // 3. 首次送货满足率
    async getDeliveryRateData({ commit }, obj) {
      let resp = await getDeliveryRate(obj);
      commit('GET_DELIVERY_RATE_DATA', resp);
    },
    // 4. 客户订单
    async getCustomerOrderData({ commit }, obj) {
      let resp = await getCustomerOrder(obj);
      commit('GET_CUSTOMER_ORDER_DATA', resp);
    },
    // 5. 订单分析-品类
    async getCategoryAnalysisData({ commit }, obj) {
      let resp = await getCategoryAnalysis(obj);
      commit('GET_CATEGORY_ANALYSIS_DATA', resp);
    },
    // 6. 订单分析-订单类型
    async getOrderTypeData({ commit }, obj) {
      let resp = await getOrderType(obj);
      commit('GET_ORDER_TYPE_DATA', resp);
    },
    // 7. 客户发货信息
    async getShipInfoData({ commit }, obj) {
      let resp = await getShipInfo(obj);
      commit('GET_SHIP_INFO_DATA', resp);
    },
    /**
     * 退货信息
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async getDashboardRejectReturn({ commit }, obj) {
      let resp = await getDashboardRejectReturn(obj);
      commit('GET_DASHBOARD_REJECT_RETURN', resp);
    },
    // soldTo下拉列表
    async soldToList({ commit }, obj) {
      let resp = await getSoldToList(obj);
      commit('GET_SOLDTO_LIST', resp);
    },
    /**
     * 获取dcNo下拉列表
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async getDcNoList({ commit }, obj) {
      let resp = await getDcNoList(obj);
      commit('GET_DCNO_LIST', resp);
    },
    // 导出
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('GET_EXPORT_DATA', resp);
    }
  }
}
export default cscDashboard



// WEBPACK FOOTER //
// ./src/page/report/cscDashboard/store/cscDashboard.store.js